/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';
import { IHospitalManager } from 'app/shared/model/hospital-manager.model';

export interface IOperationTheatre {
  id?: string;
  name?: string;
  description?: string | null;
  startTime?: number | null;
  endTime?: number | null;
  dateSuspended?: number | null;
  reasonSuspended?: string | null;
  nextMaintenanceDate?: number | null;
  lastMaintenanceDate?: number | null;
  suspended?: boolean | null;
  underMaintainance?: boolean | null;
  active?: boolean | null;
  cursor?: number | null;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  hospital?: IHospital;
  addedBy?: IHospitalManager | null;
  modifiedBy?: IHospitalManager | null;
}

export const defaultValue: Readonly<IOperationTheatre> = {
  suspended: false,
  underMaintainance: false,
  active: false,
};
